export const ACTION_STATUS_INITIAL = 'initial';
export const ACTION_STATUS_SUCCESS = 'success';
export const ACTION_STATUS_ERROR = 'error';
